import { render, staticRenderFns } from "./OptionGroupDetails.vue?vue&type=template&id=eaf3fc92&"
import script from "./OptionGroupDetails.vue?vue&type=script&lang=ts&"
export * from "./OptionGroupDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports